var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColoredLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4482 8.43701C31.4081 9.42418 32.2497 10.5227 32.9546 11.712C31.8713 11.3507 30.7102 11.0513 29.4671 10.8074C28.4153 10.1014 27.3819 9.49222 26.3594 8.98075C27.6978 8.63859 29.0714 8.45667 30.4482 8.43701Z",
    fill: "#03EEA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9983 4.2373C25.7505 4.88331 27.364 5.80245 28.7926 6.93879C27.1937 7.04563 25.6054 7.38476 23.9993 7.96324C22.3934 7.38525 20.8035 7.04563 19.2051 6.93879C20.6337 5.80245 22.2483 4.88331 23.9983 4.2373Z",
    fill: "#A3CB39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4454 3.34485C16.5615 3.18207 17.7105 3.12615 18.88 3.18712C20.0073 3.24608 21.1038 3.41135 22.1616 3.67238C20.1449 4.58196 18.4109 5.65731 16.9364 6.9433C14.9838 7.07634 12.9978 7.54144 10.9297 8.32454C11.4926 7.39229 12.1512 6.49934 12.9066 5.66134C13.6902 4.79058 14.5413 4.01908 15.4454 3.34485Z",
    fill: "#17A86E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.02879 7.0297C8.41557 5.90749 9.97767 4.99692 11.6613 4.34131C10.6464 5.9866 9.78876 7.56436 9.0918 9.09274C7.56395 9.78964 5.98565 10.6473 4.33984 11.6622C4.99649 9.97862 5.90655 8.41648 7.02879 7.0297Z",
    fill: "#FFC805"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5534 8.43701C18.93 8.45665 20.3032 8.63857 21.6416 8.98073C20.6197 9.4922 19.5867 10.1014 18.5345 10.8079C17.2918 11.0518 16.1298 11.3512 15.0469 11.7119C15.7503 10.5232 16.5934 9.42417 17.5534 8.43701Z",
    fill: "#A3CB39"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0259 10.0254C9.2453 11.7216 8.75252 13.511 8.54688 15.3256C9.75281 14.2698 11.1164 13.386 12.6604 12.6608C13.3865 11.1153 14.2709 9.75276 15.3261 8.54639C13.5125 8.75249 11.7216 9.24381 10.0259 10.0254Z",
    fill: "#17A86E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.34425 15.4433C3.18152 16.56 3.12508 17.7084 3.18605 18.8785C3.24503 20.0057 3.41029 21.1017 3.67184 22.1585C4.58136 20.1428 5.65522 18.4099 6.94279 16.9348C7.07579 14.9822 7.54092 12.9963 8.32351 10.9282C7.39179 11.4911 6.49878 12.1497 5.66029 12.9051C4.79001 13.6881 4.01802 14.5393 3.34425 15.4433Z",
    fill: "#FFC805"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 24C0.188447 22.2257 0.648046 20.4771 1.37519 18.8228C1.82112 20.7034 2.3291 22.4263 2.91763 24C2.3291 25.5737 1.82112 27.2966 1.37519 29.1777C0.648046 27.5234 0.188447 25.7748 0 24Z",
    fill: "#F28020"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.43555 17.5533C9.42271 16.5934 10.5223 15.7504 11.711 15.0469C11.3503 16.1298 11.0509 17.2918 10.8065 18.5345C10.1 19.5862 9.49074 20.6197 8.97931 21.6421C8.63713 20.3027 8.45521 18.9301 8.43555 17.5533Z",
    fill: "#17A86E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23828 23.9993C4.88433 22.2487 5.80345 20.6347 6.93982 19.2056C7.0461 20.8045 7.38575 22.3949 7.96476 24.0008C7.38575 25.6058 7.0461 27.1946 6.93982 28.7931C5.80345 27.365 4.88379 25.751 4.23828 23.9993Z",
    fill: "#FFC805"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.34442 32.556C3.18108 31.4394 3.12464 30.291 3.18669 29.1213C3.24559 27.9936 3.41038 26.8965 3.67194 25.8394C4.581 27.8555 5.65639 29.59 6.94335 31.0649C7.07643 33.0171 7.54156 35.003 8.3246 37.0716C7.39235 36.5093 6.49941 35.8501 5.66092 35.0958C4.79064 34.3117 4.01911 33.4591 3.34442 32.556Z",
    fill: "#F28020"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.02879 40.9704C5.90655 39.5826 4.99595 38.0215 4.33984 36.3364C5.98519 37.3518 7.56395 38.2105 9.0918 38.9074C9.78876 40.4353 10.6474 42.0135 11.6618 43.6593C9.97767 43.0032 8.41557 42.0926 7.02879 40.9704Z",
    fill: "#E94753"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.43555 30.4467C8.45574 29.07 8.63713 27.6968 8.97931 26.3584C9.49074 27.3809 10.1 28.4134 10.806 29.4645C11.0509 30.7082 11.3502 31.8693 11.7116 32.9532C10.5227 32.2487 9.4237 31.4071 8.43555 30.4467Z",
    fill: "#FFC805"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0263 37.9745C11.7221 38.7556 13.512 39.2474 15.3271 39.4535C14.2709 38.2471 13.387 36.8845 12.6604 35.339C11.1159 34.6124 9.75274 33.729 8.54688 32.6738C8.75345 34.4874 9.2453 36.2788 10.0263 37.9745Z",
    fill: "#F28020"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4458 44.6555C16.563 44.8188 17.7109 44.8752 18.881 44.8132C20.0083 44.7538 21.1053 44.5895 22.162 44.328C20.1454 43.4189 18.4119 42.3435 16.9374 41.0565C14.9842 40.923 12.9983 40.4584 10.9297 39.6758C11.4926 40.6076 12.1512 41.5 12.9066 42.339C13.6902 43.2093 14.5428 43.9812 15.4458 44.6555Z",
    fill: "#E94753"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9996 47.9997C22.2248 47.8108 20.4761 47.3512 18.8223 46.6241C20.7039 46.178 22.4258 45.6701 23.9996 45.0815C25.5728 45.6701 27.2952 46.178 29.1763 46.6241C27.5225 47.3512 25.7738 47.8108 23.9996 47.9997Z",
    fill: "#5100C8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5534 39.5625C16.5939 38.5759 15.7519 37.4763 15.0469 36.2876C16.1303 36.6479 17.2919 36.9477 18.5351 37.1916C19.5862 37.8986 20.6203 38.5083 21.6412 39.0198C20.3027 39.362 18.9301 39.5434 17.5534 39.5625Z",
    fill: "#F28020"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0013 43.7626C22.2497 43.1166 20.6356 42.1974 19.207 41.0611C20.8065 40.9543 22.3948 40.6151 24.0013 40.0361C25.6068 40.6151 27.1956 40.9543 28.7946 41.0611C27.3659 42.1974 25.7519 43.1166 24.0013 43.7626Z",
    fill: "#E94753"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5555 44.656C31.4394 44.8193 30.2904 44.8757 29.1209 44.8137C27.9935 44.7542 26.897 44.59 25.8398 44.3284C27.856 43.4194 29.59 42.344 31.0649 41.057C33.0177 40.9235 35.0041 40.4589 37.0716 39.6758C36.5093 40.608 35.8507 41.5005 35.0953 42.3395C34.3117 43.2097 33.4591 43.9813 32.5555 44.656Z",
    fill: "#5100C8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9705 40.9694C39.5822 42.0916 38.0205 43.0022 36.3359 43.6588C37.3508 42.013 38.2095 40.4347 38.9059 38.9069C40.4348 38.2099 42.0131 37.3513 43.6583 36.3369C43.0028 38.021 42.0922 39.5816 40.9705 40.9694Z",
    fill: "#47A2AB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4467 39.5635C29.0696 39.5434 27.6974 39.362 26.3574 39.0198C27.3804 38.5089 28.4129 37.8996 29.4641 37.1931C30.7068 36.9487 31.8698 36.6489 32.9528 36.2881C32.2483 37.4763 31.4067 38.5764 30.4467 39.5635Z",
    fill: "#E94753"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.974 37.9745C38.7551 36.2788 39.2469 34.4884 39.4535 32.6738C38.2472 33.729 36.884 34.6134 35.3395 35.3395C34.6134 36.8845 33.7295 38.2471 32.6738 39.454C34.4884 39.2474 36.2784 38.7556 37.974 37.9745Z",
    fill: "#5100C8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6575 32.5555C44.8202 31.4394 44.8766 30.2914 44.8146 29.1214C44.7557 27.9941 44.5914 26.897 44.3299 25.8403C43.4208 27.856 42.3455 29.5895 41.0585 31.0644C40.9254 33.0171 40.4603 35.0035 39.6777 37.0721C40.6089 36.5092 41.5019 35.8501 42.3404 35.0957C43.2107 34.3122 43.9832 33.4595 44.6575 32.5555Z",
    fill: "#47A2AB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0002 24.001C47.8113 25.7748 47.3517 27.5233 46.6245 29.1772C46.1785 27.2956 45.6706 25.5727 45.082 23.9995C45.6701 22.4262 46.1785 20.7039 46.6245 18.8228C47.3517 20.4771 47.8117 22.2257 48.0002 24.001Z",
    fill: "#03EEA3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.564 30.4471C38.5763 31.4071 37.4773 32.2491 36.2891 32.9536C36.6498 31.8697 36.9482 30.7087 37.1936 29.465C37.9001 28.4133 38.5088 27.3813 39.0202 26.3589C39.3624 27.6978 39.5438 29.0704 39.564 30.4471Z",
    fill: "#5100C8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7612 23.9988C43.1151 25.7504 42.196 27.364 41.0596 28.7936C40.9528 27.1941 40.6132 25.6048 40.0352 23.9988C40.6132 22.3933 40.9528 20.805 41.0596 19.2056C42.196 20.6347 43.1151 22.2482 43.7612 23.9988Z",
    fill: "#47A2AB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6555 15.4433C44.8183 16.5595 44.8742 17.7084 44.8132 18.878C44.7543 20.0057 44.5885 21.1018 44.3274 22.1585C43.4189 20.1428 42.343 18.4094 41.057 16.9349C40.9235 14.9822 40.4589 12.9963 39.6758 10.9282C40.6075 11.4911 41.5005 12.1492 42.339 12.9046C43.2093 13.6882 43.9813 14.5393 44.6555 15.4433Z",
    fill: "#03EEA3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9669 7.02768C42.0892 8.41546 43.0008 9.97761 43.6569 11.6622C42.0111 10.6473 40.4333 9.78964 38.9049 9.09272C38.209 7.56434 37.3504 5.98708 36.3359 4.34131C38.0191 4.9969 39.5802 5.90647 40.9669 7.02768Z",
    fill: "#A3CB39"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5621 17.5538C39.5425 18.9301 39.3621 20.3037 39.0194 21.6411C38.5079 20.6197 37.8977 19.5861 37.1912 18.5345C36.9478 17.2918 36.6474 16.1303 36.2871 15.0474C37.4758 15.7508 38.5749 16.5934 39.5621 17.5538Z",
    fill: "#47A2AB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.974 10.0264C36.2784 9.24528 34.4874 8.75295 32.6738 8.54736C33.7295 9.75272 34.6134 11.1163 35.339 12.6609C36.884 13.3865 38.2471 14.2703 39.4526 15.3261C39.2469 13.5125 38.7546 11.7215 37.974 10.0264Z",
    fill: "#03EEA3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9996 0C25.7738 0.188964 27.5225 0.648543 29.1763 1.37568C27.2952 1.82165 25.5728 2.3301 23.9996 2.91817C22.4258 2.3301 20.7039 1.82165 18.8223 1.37568C20.4761 0.648543 22.2248 0.188964 23.9996 0Z",
    fill: "#17A86E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5551 3.34471C31.4389 3.18245 30.2909 3.12501 29.1209 3.18698C27.9936 3.24645 26.896 3.41073 25.8398 3.67226C27.856 4.58132 29.589 5.65667 31.065 6.94367C33.0177 7.07671 35.0036 7.54182 37.0716 8.3249C36.5083 7.39267 35.8502 6.49972 35.0948 5.66172C34.3112 4.79094 33.4596 4.01896 32.5551 3.34471Z",
    fill: "#A3CB39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredLogo);
export default __webpack_public_path__ + "static/media/ColoredLogo.827c2cae543eeefc3120a23da61f652b.svg";
export { ForwardRef as ReactComponent };